import { render, staticRenderFns } from "./VendorDashboard.vue?vue&type=template&id=4f7c66ae&"
import script from "./VendorDashboard.vue?vue&type=script&lang=js&"
export * from "./VendorDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports